export const getAnoRequestParam = (year: number | null | undefined): number => {
  if (year === null || year === undefined) return 2026;
  return year;
};
